module.exports = __webpack_public_path__ + "static/media/Camera04_background.a96cf829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop/Camera04_background.png
// module id = 984
// module chunks = 0